import React from "react"
import { UIConfigContext } from "./UIConfigContext";
import { Action, ActionButton, ActionData } from "./ActionButton";
import { FanboxStyling } from "./CSSUtilities";


export type LandingPageProps = {
  showEnterButton: boolean;
  height: number;
  image: string;
  heading: string;
  subHeading: string;
  description: string;
  buttonText: string;
  imageProportion?: number;
  absolute?: boolean;
  action: Action;
  actionData: ActionData;
  noEntryText: string;
}

export const LandingPage = ({ showEnterButton, height, image, heading, subHeading, description, buttonText, imageProportion, absolute, action, actionData, noEntryText }: LandingPageProps): React.JSX.Element => {
  const uiConfig = React.useContext(UIConfigContext);
  const useAbsolute = absolute === undefined ? true : absolute;
  const imageBottom = imageProportion === undefined ? 390 : Math.floor(height * imageProportion);
  const txtPanelWidth = Math.floor(uiConfig.width * (329 / 500));
  const buttonWidth = Math.floor(uiConfig.width * 241 / 500);
  const logoTop = Math.floor(imageBottom - 390 + 343.35);

  const styling: FanboxStyling = {
    width: buttonWidth,
    height: 66,
    boundary: {
      radius: 75,
      margin: {
        quadType: 'margin',
        top: 0,
        bottom: 0,
        left: (txtPanelWidth - buttonWidth) * 0.5,
        right: (txtPanelWidth - buttonWidth) * 0.5
      }
    },
    color: {
      background: 'orange',
      foreground: 'white'
    },
    font: {
      size: 24,
      weight: 'bold'
    },
    position: {
      positioningType: 'relative',
      top: -123
    }
  }


  return (
    <div id="landingPagePanel"
      style={{
        width: uiConfig.width + "px",
        height: height + "px",
        position: useAbsolute ? "absolute" : "relative",
        backgroundColor: "black",
        overflow: 'clip'
      }}>
      <div style={{
        position: 'relative',
        overflow: 'auto',
        width: uiConfig.width + "px",
        maxWidth: uiConfig.width + "px",
        minWidth: uiConfig.width + "px",
        maxHeight: height + 'px',
        display: 'flex',
        flexDirection: 'column'
      }}>
        <div style={{
          width: uiConfig.width + "px",
          minWidth: uiConfig.width + "px",
          maxWidth: uiConfig.width + 1 + "px",
          height: imageBottom + 'px',
          minHeight: imageBottom + 'px',
          maxHeight: imageBottom + 'px',
          backgroundImage: 'url(' + image + ')',
          backgroundSize: 'cover',
          backgroundPosition: 'top left'
        }} ></div>
        <div style={{
          position: "relative",

          backgroundColor: "#1E1D1D",
          width: uiConfig.width + "px",
          maxWidth: uiConfig.width + "px",
          minWidth: uiConfig.width + "px",
          minHeight: (height - imageBottom) + 'px'

        }}>
          <div style={{ width: txtPanelWidth + "px", marginLeft: "auto", marginRight: "auto", marginTop: "150px" }}>
            <p style={{ fontSize: "45px", lineHeight: "51px", fontWeight: 900, textAlign: "center", color: "white", position: "relative", top: "-51px" }}>{heading}</p>
            <p style={{ fontSize: "45px", lineHeight: "51px", fontWeight: 900, textAlign: "center", color: "#FFB602", position: "relative", top: "-97px" }}>{subHeading}</p>
            <p style={{ fontSize: "18px", lineHeight: "28px", fontWeight: 400, textAlign: "center", color: "white", position: "relative", top: "-123px" }}>{description}</p>
            {((!showEnterButton) && (noEntryText !== undefined)) &&
              <p style={{ fontSize: "18px", lineHeight: "28px", fontWeight: 700, textAlign: "center", color: "#FFB602", position: "relative", top: "-123px" }}>{noEntryText}</p>}
            {showEnterButton && <ActionButton text={buttonText} action={action} actionData={actionData} styling={styling} prompt={'center'} />}
          </div>
        </div>
        <img src={"/images/fbLogo-small.png"} style={{
          position: "absolute",
          top: logoTop + "px",
          left: "44px",
          width: "81px",
          minWidth: "81px",
          maxWidth: "81px"
        }} />
      </div>
    </div>
  );
}